import "./Hero.css";
import logoLight from "../../../assets/svg/logo_vassabi_ua.svg";
import logoDark from "../../../assets/svg/logo_vassabi_ua_dark.svg";


export default function Hero() {
  return (
    <section className="hero">
      <div className="hero-left">

        {/* LIGHT THEME LOGO */}
        <img src={logoLight} alt="Vassabi Logo" className="hero-logo hero-logo-light"/>

        {/* DARK THEME LOGO */}
        <img src={logoDark} alt="Vassabi Logo Dark" className="hero-logo hero-logo-dark"/>

      </div>

      <div className="hero-right">
        <h1 className="hero-title">
          Your reliable partner for mobile premium offers
        </h1>

        <p className="hero-subtitle">
          MOBILE CONTENT PROVIDER / DIRECT ADVERTISER
        </p>
      </div>

    </section>
  );
}
